<h4 style="width: 211px;">{{title}}</h4>
<div class="filter-list-detail">
    <div class="custom-control custom-checkbox checkbox">
        <input type="checkbox"
               class="custom-control-input"
               #all
               [checked]="models | subFiltersSelected"
               [intermediate]="(models | subFiltersSelected) === null"
               (change)="setAllSelected(models, all.checked)"
               id="{{id}}All">
        <label class="custom-control-label" title="All" for="{{id}}All">{{allTitle}}</label>
    </div>
    <div class="custom-control custom-checkbox checkbox" *ngFor="let model of models | slice: 0: 5; let i = index">
        <input type="checkbox"
               class="custom-control-input"
               [(ngModel)]="model.selected"
               (ngModelChange)="checkChanged()"
               id="{{id}}{{i}}">
        <label class="custom-control-label" title="{{model.name}}" for="{{id}}{{i}}">{{model.name}}</label>
    </div>
    <ng-container *ngIf="models.length > 5">
        <div [collapse]="!seeMore">
            <div class="custom-control custom-checkbox checkbox" *ngFor="let model of models | slice: 5; let i = index">
                <input type="checkbox"
                       class="custom-control-input"
                       [(ngModel)]="model.selected"
                       (ngModelChange)="checkChanged()"
                       id="{{id}}{{i + 5}}">
                <label class="custom-control-label" title="{{model.name}}" for="{{id}}{{i + 5}}">{{model.name}}</label>
            </div>
        </div>
        <a class="show-filter-button"
           [class.show-block]="!seeMore"
           (click)="seeMore = !seeMore">
            {{!seeMore ? 'SHOW MORE' : 'SHOW LESS'}}
        </a>
    </ng-container>

</div>


